import { Component, Input, OnInit } from '@angular/core';
import { IncomeCategoryService } from '../income-category.service';
import { IncomeCategory } from '../income-category';
import { NotificationService } from '../../shared/notification.service';
import { SelectComparisons } from '../../shared/pipes/select.comparisons';

@Component({
  selector: 'app-income-category-select',
  templateUrl: 'select.component.html',
})
export class IncomeCategorySelectComponent extends SelectComparisons
  implements OnInit {
  /**
   * The model that we will be adding the incomeCategory to.
   */
  @Input() model: any;

  /**
   * Do we require this field in the main form it is
   * included in?
   */
  @Input() required: boolean;

  /**
   * A list of all the incomeCategories currently loaded.
   *
   * @type {IncomeCategory[]}
   */
  public incomeCategories: IncomeCategory[] = [];

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = true;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {IncomeCategoryService} incomeCategoryService
   * @param {NotificationService} notificationService
   */
  constructor(
    private incomeCategoryService: IncomeCategoryService,
    private notificationService: NotificationService,
  ) {
    super();
    this.incomeCategoryService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  /**
   * When the component is initialised we set it to load
   * page one of the incomeCategory list.
   */
  public ngOnInit(): void {
    this.loadIncomeCategories(1, 10000);
  }

  /**
   * Loads a list of incomeCategories using the given per page limit.
   *
   * @param {number} page The current page we require.
   * @param {number} limit The number of results per page.
   */
  public loadIncomeCategories(page?: number, limit?: number): void {
    const listIncomeCategories = this.incomeCategoryService
      .listIncomeCategories(page, limit)
      .subscribe((incomeCategories: IncomeCategory[]) => {
        this.incomeCategories = incomeCategories;
        listIncomeCategories.unsubscribe();
      });
  }
}
